<template>
  <Head title="Privacy" />

  <div class="max-w-3xl mx-auto px-4">
    <h2 class="text-3xl leading-tight font-bold">Privacy</h2>

    <section class="mb-8">
      <h3 class="text-2xl font-semibold mb-4">Informativa sul trattamento dei dati personali degli utenti del sito
        web</h3>
      <p class="mt-2 leading-relaxed">
        Art. 13 e 14 del Regolamento 2016/679/UE (nel seguito anche "GDPR")
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Perché questo avviso</h3>
      <p class="mt-2 leading-relaxed">
        Aquasport società sportiva dilettantistica a responsabilità limitata (nel seguito anche “Azienda” o “Titolare”)
        è impegnata nel rispetto e nella protezione della tua privacy e desidera che ti senta sicuro sia durante la
        semplice navigazione del sito sia nel caso in cui decida di registrarti fornendoci i tuoi dati personali per
        usufruire dei servizi resi disponibili ai propri Utenti e/o Clienti. In questa pagina Azienda intende fornire
        alcune informazioni sul trattamento dei dati personali relativi agli utenti che visitano o consultano il sito
        web accessibile per via telematica a partire dall’ indirizzo https://piscinaconcadelsole.it (il
        “Sito”). L’informativa è resa solo per il sito web di Azienda e non anche per altri siti web eventualmente
        consultati dall’utente tramite link (per i quali si rinvia alle rispettive informative/policies in tema
        privacy). La riproduzione od utilizzo di pagine, materiali ed informazioni contenuti all’interno del Sito, con
        qualsiasi mezzo e su qualsiasi supporto, non è consentita senza il preventivo consenso scritto di Azienda. E’
        consentita la copia e/o la stampa per uso esclusivamente personale e non commerciale (per richieste e
        chiarimenti contattare Azienda ai recapiti sotto indicati). Altri usi dei contenuti, servizi e delle
        informazioni presenti su questo sito non sono consentiti.
      </p>

      <p class="mt-2 leading-relaxed">
        Relativamente ai contenuti offerti ed alle informazioni fornite, Azienda farà in modo di mantenere i contenuti
        del Sito ragionevolmente aggiornati e rivisti, senza offrire alcuna garanzia sull’adeguatezza, esattezza o
        completezza delle informazioni fornite declinando esplicitamente ogni responsabilità per eventuali errori
        d’omissione nelle informazioni fornite nel Sito.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Origine - Dati di navigazione</h3>
      <p class="mt-2 leading-relaxed">
        Azienda informa che i dati personali da te forniti ed acquisiti contestualmente alla richiesta d’informazioni
        e/o contatto, registrazione al sito ed utilizzo dei servizi mediante smartphone o qualunque altro strumento
        impiegato per accedere ad Internet, nonché i dati necessari all’erogazione di tali servizi, ivi compresi i dati
        di navigazione e i dati utilizzati per l’eventuale acquisto dei prodotti e servizi offerti da Azienda ma anche i
        soli dati c.d. di “navigazione” del sito da parte degli Utenti, saranno trattati nel rispetto della normativa
        applicabile. I sistemi informatici e le procedure software utilizzate per il funzionamento di questo sito web
        acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita
        nell’uso della rete Internet. Si tratta di informazioni che non sono raccolte per essere associate a interessati
        identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati
        detenuti da terzi, permettere di identificare gli utenti navigatori. In questa categoria di dati rientrano gli
        “indirizzi IP” o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito, gli indirizzi
        in notazione URI (Uniform Resource Identifier) delle risorse richieste, l’orario della richiesta, il metodo
        utilizzato nel sottoporre la richiesta al server web, la dimensione del file ottenuto in risposta, il codice
        numerico indicante lo stato della risposta data dal server web (buon fine, errore, ecc.) ed altri parametri
        relativi al sistema operativo ed all’ambiente informatico dell’utente. Questi dati vengono utilizzati al solo
        fine di ricavare informazioni statistiche anonime sull’uso del sito e per controllare il corretto funzionamento
        del sito web di Azienda. Si evidenzia che i predetti dati potrebbero essere utilizzati per l’accertamento di
        responsabilità in caso di reati informatici ai danni del sito di Azienda o ad altri siti ad esso connessi o
        collegati: salva questa eventualità, allo stato i dati sui contatti web non persistono per più di pochi giorni.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Origine - Dati forniti dall'utente</h3>
      <p class="mt-2 leading-relaxed">
        Azienda raccoglie, conserva ed elabora i tuoi dati personali allo scopo di fornire i prodotti e servizi offerti
        sul Sito, ovvero per obblighi di Legge. Relativamente ad alcuni specifici Servizi, Prodotti, Promozioni, ecc.
        Azienda potrà trattare i tuoi dati anche per scopi commerciali. In tali casi, verrà richiesto un consenso
        specifico, separato, facoltativo e sempre revocabile con le modalità e ai recapiti nel seguito indicati.
      </p>
      <p class="mt-2 leading-relaxed">
        L’invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati nell’apposita sezione
        del Sito Web, nonché la compilazione di questionari (es. form), la comunicazione tramite chat, push notification
        via APP, social network, call center, etc., comporta la successiva acquisizione di alcuni tuoi dati personali,
        inclusi quelli raccolti attraverso l’utilizzo delle App e dei servizi correlati, necessari per rispondere alle
        richieste. Ti segnaliamo inoltre che in occasione dell’utilizzo della connessione mobile per accedere a
        contenuti e servizi digitali offerti direttamente da Azienda ovvero ad opera di nostri Partner potrà essere
        necessario trasferire tuoi dati personali a tali terze parti. Ti evidenziamo che potresti accedere al Sito o
        connetterti ad aree dove potresti essere abilitato a pubblicare informazioni utilizzando blog o bacheche,
        comunicare con altri, ad esempio provenendo dalla pagina Azienda su Facebook®, LinkedIn®, Youtube®, ed altri
        siti di social network, rivedere prodotti e offerte e pubblicare commenti o contenuti. Prima di interagire con
        tali aree ti invitiamo a leggere attentamente le Condizioni Generali d’Utilizzo tenendo in considerazione che,
        in talune circostanze, le informazioni pubblicate possono essere visionate da chiunque abbia accesso ad Internet
        e tutte le informazioni che includi nelle tue pubblicazioni possono essere lette, raccolte ed usate da terzi.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Finalità del trattamento e base giuridica</h3>
      <p class="mt-2 leading-relaxed">
        I dati sono trattati per le finalità:
      </p>
      <ul>
        <li>strettamente connesse e necessarie alla registrazione al sito piscinaconcadelsole.it, ai servizi e/o alle App
          sviluppate o rese disponibili da Azienda, alla fruizione dei relativi servizi informativi, alla gestione delle
          richieste di contatto o di informazioni, per l’effettuazione di acquisti di prodotti e servizi offerti
          attraverso il sito Azienda;
        </li>
        <li>per le attività ancillari connesse alla gestione delle richieste dell’Utente/Cliente ed l’invio del
          riscontro che può prevedere la trasmissione di materiale promozionale; per il perfezionamento dell’ordine di
          acquisto dei prodotti e servizi offerti, incluso gli aspetti relativi al pagamento con carta di credito, la
          gestione delle spedizioni, dell’eventuale esercizio del diritto di ripensamento previsto per gli acquisti a
          distanza, l’aggiornamento sulla disponibilità di prodotti e servizi temporaneamente non disponibili;
        </li>
        <li>correlate all’adempimento di obblighi previsti da normative comunitarie e nazionali, alla tutela dell’ordine
          pubblico, all’accertamento e repressione dei reati;
        </li>
        <li>marketing diretto, ossia invio di materiale pubblicitario, vendita diretta, compimento di ricerche di
          mercato o comunicazione commerciale di prodotti e/o servizi offerti da Azienda; tale attività potrà riguardare
          anche prodotti e servizi di Società del Gruppo Azienda ed essere eseguita mediante l’invio di materiale
          pubblicitario/informativo/promozionale e/o di inviti di partecipazione ad iniziative, eventi ed offerte volte
          a premiare gli utenti/clienti, effettuato con modalità “tradizionali” (a titolo esemplificativo posta cartacea
          e/o chiamate da operatore), ovvero mediante sistemi “automatizzati” di contatto (a titolo esemplificativo SMS
          e/o MMS, chiamate telefoniche senza l’intervento dell’operatore, e-mail, fax, applicazioni interattive), ai
          sensi dell’art. 130 c. 1 e 2 del D. lgs. 196/03 e s.m.i.;
        </li>
      </ul>
      <p class="mt-2 leading-relaxed">
        Il conferimento dei dati per le finalità di cui ai punti 1), 2) e 3), connessa ad una fase pre-contrattuale e/o
        contrattuale ovvero funzionale ad una richiesta dell’utente o prevista da una specifica previsione normativa, è
        obbligatorio e, in difetto, non sarà possibile ricevere le informazioni ed accedere ai servizi eventualmente
        richiesti; relativamente al punto 4) della presente Informativa, il consenso al trattamento dei dati da parte
        dell’utente/cliente è invece libero e facoltativo e sempre revocabile senza conseguenze sulla utilizzabilità dei
        prodotti e servizi salvo l’impossibilità per Azienda di tenere aggiornati sulle nuove iniziative o su
        particolari promozioni o vantaggi eventualmente disponibili gli utenti/clienti.
      </p>
      <p class="mt-2 leading-relaxed">
        Azienda potrà inviare comunicazioni commerciali relative a prodotti e/o servizi analoghi a quelli già forniti,
        ai sensi della Direttiva 2002/58/UE, utilizzando le coordinate di posta elettronica, o quelle cartacee, da te
        indicate in tali occasioni alle quali potrai opporti con le modalità e ai recapiti nel seguito.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Modalità, logiche del trattamento, tempi di conservazione e misure di
        sicurezza</h3>
      <p class="mt-2 leading-relaxed">
        Il trattamento è effettuato anche con l’ausilio di mezzi elettronici o comunque automatizzati ed è svolto da
        Azienda e/o da terzi di cui Azienda può avvalersi per memorizzare, gestire e trasmettere i dati stessi. Il
        trattamento dei dati sarà effettuato con logiche di organizzazione ed elaborazione dei tuoi dati personali,
        anche relativi ai log originati dall’accesso ed utilizzo dei servizi resi disponibili via web, dei prodotti e
        servizi fruiti correlate alle finalità sopra indicate e, comunque, in modo da garantire la sicurezza e la
        riservatezza dei dati. I dati personali trattati verranno conservati per i tempi previsti dalla normativa nel
        tempo applicabile.
      </p>
      <p class="mt-2 leading-relaxed">
        Sempre relativamente alla sicurezza dei dati, nelle sezioni del sito web predisposte per particolari servizi,
        dove vengono richiesti dati personali all’utente navigatore, i dati vengono crittografati tramite una tecnologia
        di sicurezza chiamata Secure Sockets Layer, abbreviata in SSL. La tecnologia SSL codifica le informazioni prima
        che queste vengano scambiate via Internet tra l’elaboratore dell’utente ed i sistemi centrali di Azienda,
        rendendole incomprensibili ai non autorizzati e garantendo in questo modo la riservatezza delle informazioni
        trasmesse; inoltre le transazioni effettuate utilizzando strumenti di pagamento elettronici sono realizzate
        utilizzando direttamente la piattaforma del Fornitore dei servizi di pagamento (PSP) e Azienda conserva solo il
        set minimo di informazioni necessario a gestire eventuali contestazioni. Proprio in riferimento agli aspetti di
        protezione dei dati personali l’utente/cliente è invitato, ai sensi dell’art. 33 del GDPR a segnalare a Azienda
        eventuali circostanze o eventi dai quali possa discendere una potenziale “violazione dei dati personali (data
        breach)” al fine di consentire una immediata valutazione e l’adozione di eventuali azioni volte a contrastare
        tale evento inviando una comunicazione a info@piscinaconcadelsole.it o contattando il Servizio Clienti. Le misure
        adottate da Azienda non esimono il Cliente dal prestare la necessaria attenzione all’utilizzo, ove richiesto, di
        password/PIN di complessità adeguata, che dovrà aggiornare periodicamente, soprattutto nel caso egli tema siano
        stati violati/conosciuti da terzi, nonché custodire con attenzione e rendere inaccessibili a terzi, al fine di
        evitarne usi impropri e non autorizzati.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Cookies</h3>
      <p class="mt-2 leading-relaxed">
        Un cookie è una breve stringa di testo che viene inviata al tuo browser ed, eventualmente, salvata sul tuo
        computer (in alternativa sul tuo smartphone/tablet o qualunque altro strumento utilizzato per accedere ad
        Internet); tale invio si verifica generalmente ogni volta che visiti un sito web. Azienda utilizza i cookie per
        diverse finalità, allo scopo di offrirti un’esperienza digitale rapida e sicura, ad esempio, permettendoti di
        mantenere attiva la connessione all’area protetta durante la navigazione attraverso le pagine del sito.
      </p>
      <p class="mt-2 leading-relaxed">
        I cookie memorizzati sul tuo terminale non possono essere utilizzati per richiamare nessun dato dal tuo hard
        disk, trasmettere virus informatici o identificare ed utilizzare il tuo indirizzo e-mail. Ogni cookie è unico in
        relazione al browser e dispositivo da te utilizzati per accedere al Sito Web o utilizzare la App di Azienda. In
        genere, la finalità dei cookie è migliorare il funzionamento del sito web e l’esperienza dell’utente
        nell’utilizzo dello stesso, anche se i cookie possono essere utilizzati per inviare messaggi pubblicitari (come
        di seguito specificato). Per maggiori informazioni su che cosa sono i cookie e come funzionano, puoi consultare
        il sito web “All about cookies” http://www.allaboutcookies.org.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Ambiti di comunicazione e trasferimento dei dati</h3>
      <p class="mt-2 leading-relaxed">
        Per il perseguimento delle finalità sopra indicate, Azienda potrà comunicare e far trattare, in Italia e
        all’estero, i dati personali degli utenti/clienti a soggetti terzi con i quali abbiamo rapporti, laddove queste
        terze parti forniscono servizi su nostra richiesta. Forniremo a queste terze parti solamente le informazioni
        necessarie a effettuare i servizi richiesti prendendo tutte le misure per tutelare i tuoi dati personali. I dati
        potranno essere trasferiti al di fuori dello Spazio Economico Europeo qualora ciò risulti necessario per la
        gestione del Suo rapporto contrattuale. In tal caso, ai soggetti destinatari dei dati saranno imposti obblighi
        di protezione e sicurezza equivalenti a quelli garantiti dal Titolare. Nel caso di utilizzo di servizi offerti
        direttamente da Partners forniremo solo i dati strettamente necessari per la loro effettuazione. In ogni caso,
        saranno comunicati i soli dati necessari al perseguimento degli scopi previsti e saranno applicate, ove
        richiesto, le garanzie applicabili ai trasferimenti di dati verso paesi terzi. Potremmo anche rendere noti i
        dati personali ai nostri fornitori di servizi commerciali, per ragioni di marketing, a tal fine nominati
        responsabili esterni del trattamento. Inoltre i dati personali potranno essere comunicati ai competenti soggetti
        pubblici ed autorità per esigenze di adempimento ad obblighi normativi o per l’accertamento di responsabilità in
        caso di reati informatici ai danni del sito nonché comunicati a, o allocati presso, soggetti terzi (in qualità
        di responsabili o, ove si tratti di fornitori di servizi di comunicazione elettronica, di autonomi titolari),
        che prestano servizi informatici e telematici (es.: servizi di hosting, di gestione e sviluppo di siti web) e di
        cui Azienda si avvale per lo svolgimento di compiti ed attività di natura anche tecnica ed organizzativa
        strumentali al funzionamento del sito web. I soggetti appartenenti alle categorie sopra riportate operano come
        distinti Titolari del trattamento o in qualità di Responsabili all’uopo nominati da Azienda.
      </p>
      <p class="mt-2 leading-relaxed">
        I dati personali potranno, inoltre, essere conosciuti dai dipendenti/consulenti di Azienda che sono
        appositamente istruiti e nominati Incaricati del trattamento.
      </p>
      <p class="mt-2 leading-relaxed">
        Le categorie dei destinatari ai quali i dati possono essere comunicati è disponibile rivolgendosi a Azienda ai
        recapiti sotto indicati.
      </p>
    </section>

    <section class="mb-8">
      <h3 class="text-xl font-semibold mb-4">Diritti degli interessati</h3>

      <p class="mt-2 leading-relaxed">
        Potrà esercitare in ogni momento i diritti che Le sono riconosciuti dalla legge, tra cui quello:
      </p>
      <ul>
        <li>di accedere ai Suoi dati personali, ottenendo evidenza delle finalità perseguite da parte del Titolare,
          delle categorie di dati coinvolti, dei destinatari a cui gli stessi possono essere comunicati, del periodo di
          conservazione applicabile, dell’esistenza di processi decisionali automatizzati;
        </li>
        <li>
          di ottenere senza ritardo la rettifica dei dati personali inesatti che La riguardano;
        </li>
        <li>
          di ottenere, nei casi previsti, la cancellazione dei Suoi dati;
        </li>
        <li>
          di ottenere la limitazione del trattamento o di opporsi allo stesso, quando possibile;
        </li>
        <li>
          di richiedere la portabilità dei dati che Lei ha fornito a Azienda, vale a dire di riceverli in un formato
          strutturato, di uso comune e leggibile da dispositivo automatico, anche per trasmettere tali dati ad un altro
          titolare, nei limiti e con in vincoli previsti dall’art. 20 del GDPR;
        </li>
      </ul>
      <p class="mt-2 leading-relaxed">
        Inoltre potrà proporre reclamo all’Autorità Garante per la Protezione dei Dati Personali ai sensi dell’art. 77
        del GDPR.
      </p>
      <p class="mt-2 leading-relaxed">
        Per i trattamenti di cui al punto 4) delle finalità il Cliente potrà sempre revocare il consenso ed esercitare
        il diritto di opposizione al marketing diretto (in forma “tradizionale” e “automatizzata”). L’opposizione, in
        assenza di indicazione contraria, verrà riferita tanto alle comunicazioni tradizionali quanto a quelle
        automatizzate.
      </p>
    </section>

    <section>
      <h3 class="text-xl font-semibold mb-4">Titolare del Trattamento</h3>
      <p class="mt-2 leading-relaxed">
        Titolare del trattamento, ai sensi dell’art. 4 del Codice e del GDPR, è Aquasport società sportiva
        dilettantistica a responsabilità limitata Via Istria 9- 96045 Terni (TR) , P.IVA: 01401630551- CF: 91050800555,
      </p>
      <p class="mt-2 leading-relaxed">
        I diritti sopra indicati possono essere esercitati su richiesta dell’Interessato con le modalità rese note dal
        Servizio Clienti o sul sito WEB della Società.
      </p>
      <p class="mt-2 leading-relaxed">
        L’uso del Sito Web, incluso di quelli destinati a tablet e/o smartphone, da parte del Cliente e/o dell’Utente
        implica la piena conoscenza e accettazione del contenuto e delle eventuali indicazioni incluse in questa
        versione di informativa pubblicata da Azienda nel momento in cui il sito viene acceduto. Azienda informa che la
        presente informativa può essere modificata senza alcun preavviso e quindi ne consiglia una lettura periodica.
      </p>
      <p class="mt-2 leading-relaxed">
        Il Titolare del trattamento
      </p>
      <p class="mt-2 leading-relaxed">
        Aquasport società sportiva dilettantistica a responsabilità limitata</p>
    </section>
  </div>
</template>

<script>
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
  },
  layout: PageLayout,
};
</script>
